// 方案切换操作
import { MiscUtil, filterSort } from '@/utils/miscUtil'
import createService from '../../utils/serviceUtil/creators'
import createService3d from '../../utils/serviceUtil/creators/index3d'
import { MapView } from '../map2d/mapView'

// 全部方案种类
const SCENARIOTYPES = {
    Vector: 'vector',
    Image: 'image',
    DEM: 'dem',
    // Globe: 'globe'
}

// 种类和具体描述
const Config = [
    { name: '矢量', type: SCENARIOTYPES.Vector },
    { name: '影像', type: SCENARIOTYPES.Image },
    // { name: '地形', type: SCENARIOTYPES.DEM },
    // { name: '三维', type: SCENARIOTYPES.Globe }
]

/**
 * 根据方案创建图层
 * @param {SCENARIOTYPES} scenarioType
 * @param {Array} scenarios
 */
async function getLayersByScenarioType(scenarioType, scenarios) {
    const scenario = scenarios.find(s => s.type.toLowerCase() === scenarioType)
    if (scenario) {
        const { mapservices, maxZoom, minZoom } = scenario
        MapView.map.setMaxZoom(maxZoom);
        MapView.map.setMinZoom(minZoom);
        // .reverse()
        const layers = await Promise.all(
            [...mapservices].reverse().map(l => {

                // 配置信息
                const info = l.info
                let [minZoom, maxZoom] = info.zoomRange
                maxZoom =  l.info.length -1
                if (scenarioType !== 'globe') {
                    // 创建图层
                    return createService(
                        info.type,
                        info,
                        minZoom,
                        maxZoom,
                        MapView.map
                    ).catch(err => {
                        // 单独捕捉错误（避免创建失败整个promise异常）
                        console.error('创建图层失败：', info.name, err)
                        return false
                    })
                } else {
                    // 创建图层
                    return createService3d(
                        info.type,
                        info,
                        minZoom,
                        maxZoom
                    ).catch(err => {
                        // 单独捕捉错误（避免创建失败整个promise异常）
                        console.error('创建图层失败：', info.name, err)
                        return false
                    })
                }
            })
        )
        return layers.filter(layer => !!layer)
    }
    return []
}

/**
 * 获取原始配置
 * @param {SCENARIOTYPES} scenarioType
 * @param {Array} scenarios
 */
function getScenarioByType(scenarioType, scenarios) {
    const scenario = scenarios.find(s => s.type.toLowerCase() === scenarioType)
    return scenario
}

/**
 * 方案操作
 */
export const ScenarioView = {
    // 默认图层配置json
    _scenarioArray: null,

    /**
     * @async
     * 初始化底图方案
     */
    async init() {
        return new Promise((resolve, reject) => {
            if (this._scenarioArray) {
                resolve()
            } else {
                MiscUtil.fetch('admin/mapFront/queryDefaultScenario').then(json => {
                    this._scenarioArray = json
                    resolve()
                }, reject)
            }
        })
    },

    /**
     * 符合配置的方案类型
     * @return {Array}
     */
    get ScenariosTypes() {
        const { scenarios } = global.CONFIG
        return filterSort(Config, scenarios, 'type')
    },

    /**
     * 默认方案，通过外部配置筛选得到
     * @return {Number}
     */
    get defaultScenarioIndex() {
        const { defaultScenario } = global.CONFIG
        if (defaultScenario) {
            const i = this.ScenariosTypes.findIndex(
                ({ type }) => type === defaultScenario
            )
            if (i >= 0) {
                return i
            }
        }
        return 0
    },

    /**
     * @api
     * 通过type获取layers
     * @param {String} scenarioType
     */
    async getLayers(scenarioType) {
        return this.init().then(() =>
            getLayersByScenarioType(scenarioType, this._scenarioArray)
        )
    },
    /**
     * @api
     * 通过type获取scenario
     * @param {String} scenarioType
     */
    async getScenarioByType(scenarioType) {
        return this.init().then(() =>
            getScenarioByType(scenarioType, this._scenarioArray)
        )
    }
}
